import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CampingIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M8.67577 18.2387H7.08971L12 9.86527L16.9103 18.2387H15.3242L12 12.5376L8.67577 18.2387ZM4 20L10.9716 8.11149L9.07916 4.8844L10.6174 4L12 6.35771L13.3826 4L14.9208 4.8844L13.0284 8.11149L20 20H4ZM10.7774 18.1569L12 16.0601L13.2226 18.1569H10.7774Z"
      />
    </SvgIcon>
  );
});
